<template>
  <div class="w-full h-full relative">
    <!-- <DirectionalLight :pz="-100" :py="23" :intensity="0.7"></DirectionalLight>
    <DirectionalLight :pz="100" :py="23" :intensity="0.7"></DirectionalLight>
    <DirectionalLight :px="-100" :py="23" :intensity="0.7"></DirectionalLight>
    <DirectionalLight :px="100" :py="23" :intensity="0.7"></DirectionalLight>
    <GameNPC :char="'david'" :pz="-20">
    </GameNPC>
    <CamControl :py="-13"></CamControl>
    <SwatWalk></SwatWalk> -->


    <!-- <Flame></Flame> -->
    <O3D :scale="{ x: 1.5, y: 1, z: 1 }">
      <FastFlame v-if="ctx.renderer"></FastFlame>
    </O3D>
    <Bloomer :settings="{
      exposure: 1.0,
      bloomStrength: 1.7,
      bloomThreshold: 20.72 / 100.0,
      bloomRadius: 72.99 / 100.0 * 2
    }" v-if="ctx.renderer"></Bloomer>
    <slot></slot>
    <!-- <Game :nolight="true"></Game> -->
  </div>
</template>

<script>
import { Scene } from 'three'
import { PCamera } from '../../Reusable/PCamera'
import { getScreen } from '../../Reusable/O3DG2'
export default {
  mixins: [
    require('../../Reusable/RenderRoot').RenderRoot
  ],
  data () {
    return {
      screen: false,
      scene: false,
      camera: false
    }
  },
  methods: {
    async setupGraphics () {
      this.scene = new Scene()
      this.camera = new PCamera({ element: this.ctx.element, onResize: this.onResize })
      this.camera.position.z = 180

      this.onResize(() => {
        this.screen = getScreen({ camera: this.camera, depth: this.camera.position.z })
      })
      this.scene.add(this.o3d)

      this.$emit('vm', this)
    }
  },
  mounted () {
    this.setupGraphics()
  }
}
</script>

<style>
</style>
